
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {Obi07ChartStyles as Obi07ChartStylesElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-07-chart-styles.js';
 
 
 

 
 export const Obi07ChartStyles = createComponent({
   react: React,
   tagName: 'obi-07-chart-styles',
   elementClass: Obi07ChartStylesElement,
   events: {
     
   }
  });
 
 